<template>
    <div class="aba-emrpesa">
        <container-loader v-if="isLoading && !$store.getters.isLoading" />
        <div class="vertical-flow">
            <div class="columns">
                <div
                    class="column"
                    :class="[
                        permissao.create &&
                        !assUsuarioIntegracao &&
                        permissaoUsuario.create &&
                        !usuarioIntegracao
                            ? 'is-4'
                            : permissao.create &&
                              !assUsuarioIntegracao &&
                              (!permissaoUsuario.create || usuarioIntegracao)
                            ? 'is-6'
                            : permissaoUsuario.create &&
                              !usuarioIntegracao &&
                              (!permissao.create || assUsuarioIntegracao)
                            ? 'is-6'
                            : 'is-8',
                    ]"
                >
                    <search-bar
                        :onSearch="debouncedOnSearch"
                        tooltipLabel="msg-campo-busca-usuario"
                    />
                </div>

                <div
                    class="column situacao-select"
                    :class="[
                        permissao.create &&
                        !assUsuarioIntegracao &&
                        !usuarioIntegracao &&
                        permissaoUsuario.create
                            ? 'is-2'
                            : permissao.create &&
                              !assUsuarioIntegracao &&
                              (!permissaoUsuario.create || usuarioIntegracao)
                            ? 'is-3'
                            : permissaoUsuario.create &&
                              !usuarioIntegracao &&
                              (!permissao.create || assUsuarioIntegracao)
                            ? 'is-3'
                            : 'is-4',
                    ]"
                >
                    <label v-text="$t('situacao')" />
                    <v-select
                        ref="situacaoInput"
                        class="is-100"
                        label="label"
                        :options="situacoes"
                        @input="onSituacaoChanged"
                        v-model="situacao"
                    >
                        <template slot="option" slot-scope="option">
                            {{ $t(option.label) }}
                        </template>
                        <template slot="selected-option" slot-scope="option">
                            {{ $t(option.label) }}
                        </template>
                        <template slot="no-options">{{ $t('sem-resultados') }}</template>
                    </v-select>
                </div>

                <div class="column is-3" v-if="!assUsuarioIntegracao && permissao.create">
                    <button
                        class="save-btn botao-acao"
                        type="button"
                        @click="showModalUsuariosNaoAssociados"
                    >
                        {{ $t('vincular-usuario') }}
                    </button>
                </div>
                <div
                    class="column is-3"
                    v-if="permissaoUsuario.create && !usuarioIntegracao && permissao.create"
                >
                    <button
                        class="save-btn botao-acao"
                        type="button"
                        @click="
                            $router.push({
                                name: 'usuario-gerenciar-new',
                                query: {
                                    tela: 'empresa-usuario',
                                    id: $route.params.id,
                                    name: $route.params.name,
                                    dadoscadastrais: $parent.abaSelecionada,
                                    politicacomercial: $route.query.politicacomercial
                                        ? $route.query.politicacomercial
                                        : null,
                                    contexto:
                                        isVenda || isDespesa || isPromotor
                                            ? $route.meta.contexto.slice(0, 3)
                                            : $route.meta.contexto.slice(0, 4),
                                },
                            })
                        "
                    >
                        {{ $t('adicionar-usuario') }}
                    </button>
                </div>
            </div>

            <div class="registry-wrapper">
                <empty-table-message v-if="isEmpty" />
                <b-table
                    v-else
                    :data="assusuarioempresa"
                    class="data-table"
                    @sort="sortTable"
                    backend-sorting
                >
                    <b-table-column
                        v-for="(f, i) in fields"
                        :key="i"
                        :field="f.key"
                        :label="f.key != 'excluir' ? $t(f.key) : ''"
                        :width="f.width"
                        :class="{
                            'excluir-field': f.key == 'excluir',
                        }"
                        :sortable="f.sortable"
                        :custom-sort="f.sortFn"
                        v-slot="props"
                    >
                        <div v-if="f.key == 'nome'">
                            <span>{{ props.row[f.key] }}</span>
                        </div>
                        <div v-else-if="f.key == 'replicapda'">
                            <b-tag
                                class="table-tag table-tag-full-width"
                                v-if="props.row['replicapda'] == 3"
                                type="is-success"
                                size="is-medium"
                                >{{ $t('ativo') }}</b-tag
                            >
                            <b-tag
                                class="table-tag table-tag-full-width"
                                v-else
                                type="is-danger"
                                size="is-medium"
                                >{{ $t('inativo') }}</b-tag
                            >
                        </div>
                        <div v-else-if="f.key == 'excluir'">
                            <b-button
                                v-if="permissao.update && !assUsuarioIntegracao"
                                class="action-button"
                                :type="props.row['replicapda'] == 3 ? 'is-danger' : 'is-success'"
                                :icon-right="props.row['replicapda'] == 3 ? 'delete' : 'check'"
                                @click="promptChangeSituacao(props.row)"
                                v-tippy
                                :title="$t(props.row['replicapda'] == 3 ? 'desativar' : 'reativar')"
                            />
                        </div>
                        <div v-else>
                            {{ props.row[f.key] }}
                        </div>
                    </b-table-column>
                </b-table>
                <PaginationViewer
                    class="mb-0"
                    :resetPagination="pagination.resetPagination"
                    :totalItems="pagination.totalRows"
                    :perPageOptions="pagination.perPageOptions"
                    :optionStarted="pagination.optionStarted"
                    @change="updatePagination"
                />
            </div>

            <!-- MODAL DE ASSOCIACAO -->
            <b-modal :active.sync="showModalAssociacao">
                <div class="bg">
                    <UsuarioModal :idempresa="$route.params.id" @fecharModal="fecharModal" />
                </div>
            </b-modal>
        </div>
    </div>
</template>

<script>
// SERVICES
import UsuarioService from '@/services/vendas/empresa/abas/AssUsuarioEmpresaService';
import UsuarioModal from '../modal/UsuarioModal.vue';

// COMPONENTS
import ContainerLoader from '@/components/content/loader/ContainerLoader';

export default {
    components: {
        ContainerLoader,
        UsuarioModal,
    },
    data() {
        return {
            assUsuarioIntegracao: this.$store.state.user.tabelasERPWebServer.includes(
                'ASSUSUARIOEMPRESA'
            ),
            usuarioIntegracao: this.$store.state.user.tabelasERPWebServer.includes('USUARIO'),
            assusuarioempresa: [],
            fields: [
                { key: 'codigo', width: '15%', sortable: true, sortFn: null },
                { key: 'nome', width: null, sortable: true, sortFn: null },
                { key: 'replicapda', width: 80, sortable: true, sortFn: null },
                { key: 'excluir', width: 20, sortable: false, sortFn: null },
            ],
            service: new UsuarioService(this.$http, this.$router),
            permissao: false,
            permissaoUsuario: false,
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            situacao: { id: 4, label: 'todos' },
            situacoes: [
                { id: 4, label: 'todos' },
                { id: 3, label: 'ativos' },
                { id: 2, label: 'inativos' },
            ],
            isLoading: false,
            isEmpty: false,
            debouncedOnSearch: null,
            queryFilter: '',
            column: 'nome',
            order: 'asc',
            isSaving: false,
            delete: null,
            showModalAssociacao: false,
            userSelfUpdate: false,

            isVenda: this.$route.meta.contexto == 'vendas',
            isDespesa: this.$route.meta.contexto == 'despesas',
            isPromotor: this.$route.meta.contexto == 'promotor',
            isAgro: this.$route.meta.contexto == 'agro',
        };
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];

        if (this.isVenda) {
            this.permissao = this.hasPermissionAccess(
                'vendas',
                'empresa',
                'ven-empresa-dados-cadastrais-usuario'
            );
        } else if (this.isDespesa) {
            this.permissao = this.hasPermissionAccess(
                'des',
                'empresa',
                'des-empresa-dados-cadastrais-usuario'
            );
        } else if (this.isPromotor) {
            this.permissao = this.hasPermissionAccess(
                'promotor',
                'empresa',
                'pro-empresa-dados-cadastrais-usuario'
            );
        } else if (this.isAgro) {
            this.abrev = this.$route.meta.contexto.slice(0, 4);
            this.permissao = this.hasPermissionAccess(
                'agro',
                'empresa',
                'agro-empresa-dados-cadastrais-usuario'
            );
        }

        this.permissaoUsuario = this.hasPermissionAccess(
            'admin',
            'gerenciar-usuarios',
            'admin-gerenciar-usuarios'
        );

        if (!this.permissao.read) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'usuario' },
            });
        } else {
            this.debouncedOnSearch = this.debounce(this.onSearch, 500);
            this.carregarDados();
        }
    },
    methods: {
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;

            this.isLoading = true;

            this.findAll(
                this.column,
                this.order,
                currentPage - 1,
                this.pagination.perPage,
                this.situacao.id,
                this.$route.params.id,
                this.queryFilter
            )
                .then(this.mapItems)
                .then((value) => {
                    this.assusuarioempresa = value;
                    this.isEmpty = this.assusuarioempresa.length <= 0;
                })
                .catch((e) => {
                    this.isEmpty = true;
                    this.$root.showMessage('error', 'msg-erro-load');
                    console.error('Erro ao carregar as tabelas de preços.');
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        findAll(column, order, page, limit, situacao, idempresa, ...params) {
            if (this.isVenda) {
                return this.service.findAllVendas(
                    column,
                    order,
                    page,
                    limit,
                    situacao,
                    idempresa,
                    ...params
                );
            } else if (this.isPromotor) {
                return this.service.findAllPromotor(
                    column,
                    order,
                    page,
                    limit,
                    situacao,
                    idempresa,
                    ...params
                );
            } else if (this.isDespesa) {
                return this.service.findAllDespesas(
                    column,
                    order,
                    page,
                    limit,
                    situacao,
                    idempresa,
                    ...params
                );
            } else {
                return this.service.findAllAgro(
                    column,
                    order,
                    page,
                    limit,
                    situacao,
                    idempresa,
                    ...params
                );
            }
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;

            return body.content.map((m) => {
                return {
                    codigo: m.usuario.idusuarioerp,
                    idassusuarioempresa: m.idassusuarioempresa,
                    nome: m.usuario.nome,
                    replicapda: m.replicapda,
                };
            });
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados(this.pagination.currentPage);
        },
        onSituacaoChanged(val) {
            this.situacao = val
                ? this.situacoes.filter((v) => v.id == val.id)[0]
                : this.situacoes[0];
            this.carregarDados();
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
        promptChangeSituacao(row) {
            this.userSelfUpdate = this.$store.state.user.idusuarioerp == row.codigo;
            this.delete = row;

            if (row.replicapda == 3) {
                message = this.userSelfUpdate
                    ? 'msg-confirmacao-refresh-desativacao-n'
                    : 'msg-confirmacao-desativacao-n';
            } else {
                message = this.userSelfUpdate
                    ? 'msg-confirmacao-refresh-reativacao-n'
                    : 'msg-confirmacao-reativacao-n';
            }
            let message = this.$t(message, { n:row.nome.toLocaleUpperCase()  });
            this.$root.confirm({
                message: message,
                onConfirm: () => this.updateSituacaoRegistro(),
                onCancel: () => this.removePrompt(),
            });
        },
        removePrompt() {
            this.delete = null;
        },
        updateSituacaoRegistro() {
            let tempFailure =
                this.delete.replicapda == 3
                    ? 'msg-erro-ao-reativar-associacao-usuario'
                    : 'msg-erro-ao-desativar-associacao-usuario';

            let tempAssusuarioempresa = {
                idassusuarioempresa: this.delete.idassusuarioempresa,
                replicapda: this.delete.replicapda == 3 ? 2 : 3,
            };

            this.isLoading = true;

            this.updateSituacao(tempAssusuarioempresa)
                .then((r) => {
                    if (r.status == 200) {
                        let tempSuccess =
                            r.content.replicapda == 3
                                ? 'msg-sucesso-ao-reativar-associacao-usuario'
                                : 'msg-sucesso-ao-desativar-associacao-usuario';
                        this.$root.showMessage('success', tempSuccess);

                        // Caso o usuário modifique a si mesmo é necessário recarregar a aplicação
                        if (this.userSelfUpdate) {
                            setTimeout(() => {
                                window.location.reload();
                            }, 1000);
                        }
                        this.carregarDados(this.pagination.currentPage);
                    } else if (r.status == 500) {
                        this.$root.showMessage('error', 'Erro ao atualizar status.');
                    }
                })
                .catch((e) => {
                    console.error('Erro ao atualizar status.', e);
                    this.$root.showMessage('error', tempFailure);
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.delete = null;
                });
        },
        updateSituacao(assusuarioempresa) {
            if (this.isVenda) return this.service.updateSituacaoVendas(assusuarioempresa);
            else if (this.isPromotor) return this.service.updateSituacaoPromotor(assusuarioempresa);
            else if (this.isDespesa) return this.service.updateSituacaoDespesas(assusuarioempresa);
            else return this.service.updateSituacaoAgro(assusuarioempresa);
        },
        showModalUsuariosNaoAssociados() {
            this.showModalAssociacao = !this.showModalAssociacao;
        },
        fecharModal() {
            this.showModalAssociacao = false;
            this.carregarDados();
            this.$root.showMessage('success', 'msg-sucesso-ao-adicionar-associacao');
        },
    },
};
</script>

<style lang="scss" scoped>
.aba-emrpesa {
    height: 100%;

    .situacao-select {
        div {
            height: 40px;
        }
    }

    .botao-acao {
        margin-top: 24px;
        width: 100%;
        height: 40px;
    }

    @media (max-width: 760px) {
        .situacao-select {
            width: 100%;
            padding-bottom: 0.8rem;
        }

        .botao-acao {
            margin-top: 0;
        }
    }
}
</style>
